import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

import {
  CftBox,
  CftLabel,
  CftFormField,
  CftError,
  CftFormControl,
  CftBoxWrapper,
} from "../../../components";

import { carbonInputsTypes } from "./carbonChanges.consts";

function CarbonInputsFields({ name, id }) {
  const {
    t,
    i18n: { language },
  } = useTranslation(["cft"]);

  const { values } = useFormikContext();

  const carbonInputFromId =
    id !== 0
      ? values.managementPractice.carbon_changes[id - 1].inputs.inputs_from
      : null;

  return (
    <>
      <h4 className="mb-7" style={{ textAlign: "center" }}>
        {t("cft:carbonChanges.carbonInputs.title", "Carbon inputs")}
      </h4>
      <>
        <CftFormControl>
          <CftLabel label={t("cft:carbonChanges.form.11", "Zmienione z...")} />
          <CftFormField name={`${name}.inputs.inputs_from`}>
            {({ value, helpers, meta }) => (
              <>
                <CftBoxWrapper>
                  {carbonInputsTypes.map(tillage => (
                    <CftBox
                      key={`inputs_from${tillage.id}`}
                      isActive={value === tillage.id}
                      onClick={() => {
                        helpers.setValue(tillage.id);
                      }}
                      isInvalid={meta.touched && meta.error}
                      variant="small"
                    >
                      <p>{tillage[language]}</p>
                    </CftBox>
                  ))}
                </CftBoxWrapper>
                <CftError
                  isActive={meta.touched && meta.error}
                  message={meta.error}
                  textAlign="center"
                />
              </>
            )}
          </CftFormField>
        </CftFormControl>
        <CftFormControl>
          <CftLabel label={t("cft:carbonChanges.form.15", "Zmieniony na...")} />
          <CftFormField name={`${name}.inputs.inputs_to`}>
            {({ value, helpers, meta }) => (
              <>
                <CftBoxWrapper>
                  {carbonInputsTypes
                    .filter(tillage => {
                      if (carbonInputFromId) {
                        return carbonInputFromId === tillage.id;
                      }

                      return true;
                    })
                    .map(tillage => (
                      <CftBox
                        key={`inputs_to_${tillage.id}`}
                        isActive={value === tillage.id}
                        onClick={() => {
                          helpers.setValue(tillage.id);
                        }}
                        isInvalid={meta.touched && meta.error}
                        variant="small"
                      >
                        <p>{tillage[language]}</p>
                      </CftBox>
                    ))}
                </CftBoxWrapper>
                <CftError
                  isActive={meta.touched && meta.error}
                  message={meta.error}
                  textAlign="center"
                />
              </>
            )}
          </CftFormField>
        </CftFormControl>
      </>
    </>
  );
}

export default CarbonInputsFields;
